// extracted by mini-css-extract-plugin
export default {"AddMemberToGroupContainer":"CreateGroup_AddMemberToGroupContainer__ed-nJ","btnToAddMembers":"CreateGroup_btnToAddMembers__n-CR7","selectAGroup":"CreateGroup_selectAGroup__MtH-c"};